/* <cr-newsletter-popup> — mockup script.js:340-358.
   Opens after `delay` seconds or once the visitor scrolls past `scroll`% of the page, once per session
   (sessionStorage) or once ever (localStorage). Waits while another overlay is open. Never auto-opens in the
   Theme Editor (select the section to preview it). After a sign-up, Shopify reloads the page with
   ?customer_posted=true#<form id>; the popup then reopens on its thank-you state. */
if (!customElements.get('cr-newsletter-popup')) {
  customElements.define('cr-newsletter-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.cr-popup__dialog');
      this.querySelectorAll('[data-cr-popup-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.storage = this.dataset.frequency === 'ever' ? 'localStorage' : 'sessionStorage';
      this.key = 'cr_popup_seen';

      const thanks = this.querySelector('[data-cr-popup-thanks]');
      const formWrap = this.querySelector('[data-cr-popup-form-wrap]');
      const ownForm = window.location.hash === '#' + this.dataset.formId;
      if (ownForm && thanks && thanks.dataset.posted === 'true') {
        formWrap.hidden = true;
        thanks.hidden = false;
        this.open();
        return;
      }
      if (ownForm && thanks && thanks.dataset.errors === 'true') { this.open('input[type="email"]'); return; }
      if (thanks && !ownForm) thanks.hidden = true;

      if (window.Shopify && window.Shopify.designMode) {
        this.onSelect = (e) => { if (e.target.contains(this)) this.open(); };
        this.onDeselect = (e) => { if (e.target.contains(this)) this.close(); };
        document.addEventListener('shopify:section:select', this.onSelect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);
        return;
      }
      if (this.dataset.enabled !== 'true' || this.seen()) return;
      if (this.dataset.hideMobile === 'true' && window.matchMedia('(max-width: 749px)').matches) return;

      this.timer = setTimeout(() => this.show(), (parseInt(this.dataset.delay, 10) || 0) * 1000);
      const pct = parseInt(this.dataset.scroll, 10) || 0;
      if (pct > 0) {
        this.onScroll = () => {
          if (window.scrollY > document.documentElement.scrollHeight * (pct / 100)) {
            clearTimeout(this.timer);
            window.removeEventListener('scroll', this.onScroll);
            this.show();
          }
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onSelect) {
        document.removeEventListener('shopify:section:select', this.onSelect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
      }
      if (window.CR && window.CR.isOpen('popup')) window.CR.closeOverlay('popup', { restoreFocus: false });
    }

    // Storage can be blocked (private mode); treat that as "not seen" but never throw.
    seen() { try { return !!window[this.storage].getItem(this.key); } catch (e) { return false; } }
    markSeen() { try { window[this.storage].setItem(this.key, '1'); } catch (e) {} }

    show() {
      if (this.seen() || window.CR.isOpen('popup')) return;
      if (window.CR.anyOpen(['menu', 'cart', 'quickview', 'search'])) { this.timer = setTimeout(() => this.show(), 4000); return; }
      this.markSeen();
      this.open('input[type="email"]');
    }

    open(focus) { window.CR.openOverlay(this, { kind: 'popup', box: this.dialog, focus: focus || '.cr-icon-btn' }); }
    close() { window.CR.closeOverlay('popup'); }
  });
}
